<script setup lang="ts">
const userStore = useUserStore();

const checkSettingPin = () => {
  if(userStore.user ){
    const isPinSet = localStorage.getItem(`isPinSet${userStore.user?.id}`);
    
    if(isPinSet){
      if(isPinSet == 'false'){
        const modal = document.getElementById('settingPinModal')
        if(modal){
          const modalInstance = new bootstrap.Modal(modal, {
            keyboard: false,
            backdrop: 'static'
          })
          modalInstance.show();
        }
      }
    }
  }
}

onMounted(() => {
  checkSettingPin()
})

</script>
<template>
  <div class="layout-container">
    <!-- Navbar -->
    <NavBar />
    <!-- End Navbar -->

    <!-- Modal Login -->
    <FormLogin />

    <FormModalSetPin />
    <!-- End Modal Login -->

    <ButtonHelp />

    <div class="content">
      <slot />
    </div>

    <!-- Pre-Footer -->
    <PreFooter class="prefooter" />
    <!-- End Pre-Footer -->
  
    <!-- Footer -->
    <Footer class="footer" />
    <!-- End Footer -->
  </div>
</template>

<style scoped>
* {
  font-family: 'Poppins', sans-serif;
}

.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 20px; /* Jarak antara konten dan PreFooter */
}

.prefooter {
  margin-top: 20px;
}

.footer {
  background-color: #f8f9fa;
  padding: 20px 0;
}
</style>
